import '../common/bn-tabs';
import '../work-orders/parts/work-order-list';
import './parts/schedule-locations';
import './parts/schedule-items';
import { html, css, LitEntity, SirenActionMixin } from '../utility/lit-entity';
import { IndexMixin } from '../utility/index-mixin';
import { StoreMixin } from '../utility/store-mixin';
import { sharedStyles } from '../styles/shared-styles';

class WorkOrderSchdeduleIndex extends StoreMixin(IndexMixin(SirenActionMixin(LitEntity))) {
  static get properties() {
    return {
      userLocationsHref: { type: String, attribute: false },
      workOrdersHref: { type: String, attribute: false },
      userId: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .header {
        margin: 0 .5rem .5rem;
      }
    `];
  }

  render() {
    const view = this.currentView || 'today';
    const query = this.userId ? `?userId=${encodeURIComponent(this.userId)}` : '';
    return html`
      <lit-entity .href="${this.userId}" @update="${this._onUpdateUser}"></lit-entity>
      <div class="header">
        <h1>Scheduled Work Orders</h1>
      </div>
      <bn-tabs>
        <bn-tab href="/work-order-schedule/locations/today${query}" ?active="${view === 'today'}">Today</bn-tab>
        <bn-tab href="/work-order-schedule/locations/all${query}" ?active="${view === 'all'}">All</bn-tab>
        <bn-tab href="/work-order-schedule/locations/completed${query}" ?active="${view === 'completed'}">Completed</bn-tab>
      </bn-tabs>
      ${super.render()}
    `;
  }

  getViews() {
    return [
      {
        default: true,
        name: 'today',
        render: () => html`<schedule-locations today .href="${this.userLocationsHref}"></schedule-locations>`,
      },
      {
        name: 'all',
        render: () => html`<schedule-locations .href="${this.userLocationsHref}"></schedule-locations>`,
      },
      {
        name: 'completed',
        render: () => html`<work-order-list .href="${this.workOrdersHref}" historical full-path></work-order-list>`,
      },
    ];
  }

  _updateHrefs(entity) {
    this.userLocationsHref = this.getHref('https://api.binsentry.com/rel/work-order-locations', entity);
    this.workOrdersHref = this.getHref('https://api.binsentry.com/rel/work-orders', entity);
  }

  _onUpdateUser(e) {
    const { entity } = e.detail;
    this._updateHrefs(entity);
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this._updateHrefs(this.entity);
  }

  _stateChanged({ query }) {
    this.userId = (query || {}).userId;
  }
}

customElements.define('work-order-schedule-location-index', WorkOrderSchdeduleIndex);
